import React from "react";
import { Route, RouteProps, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import { selectCompany } from "../../store/context/selectors";
import ICompany from "../../models/ICompany";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import ErrorComponent from "../ErrorComponent";

export const userInRoles = (routeRoles: string[] | undefined, userRoles: string[]) => {
  if (!routeRoles) {
    return true;
  }

  for (let i = 0; i < routeRoles.length; i++) {
    if (userRoles.includes(routeRoles[i])) {
      return true;
    }
  }
  return false;
};

export interface IAuthorizeRouteProps extends RouteProps {
  ready: boolean;
  isAuthenticated: boolean;
  userRoles: Array<string>;
  roles?: Array<string>;
  company?: ICompany;
  unauthorizedComponent?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  displayUnauthorizedAsBackup?: boolean;
}

function AuthorizeRoute(props: IAuthorizeRouteProps) {
  const { ready, isAuthenticated: authenticated, roles: routeRoles, userRoles, company, displayUnauthorizedAsBackup } = props;

  const { component: Component, unauthorizedComponent: Unauthorized, ...rest } = props;

  const getComponent = (routeProps: RouteComponentProps) => {
    if (authenticated && company) {
      if (userInRoles(routeRoles, userRoles)) {
        return Component && <Component {...routeProps} />;
      } else if (displayUnauthorizedAsBackup) {
        return Unauthorized && <Unauthorized {...routeProps} />;
      } else {
        return <ErrorComponent msg="Sorry, you are not authorized to view this page." />;
      }
    } else if (Unauthorized) {
      return <Unauthorized {...routeProps} />;
    }
    // just show the signup card
    return <span>&nbsp;</span>;
  };

  return (
    <Route
      {...rest}
      render={routeProps => (
        <WithLoadingSpinners isLoading={!ready} message="Loading...">
          {getComponent(routeProps)}
        </WithLoadingSpinners>
      )}
    />
  );
}

export default connect((state: IApplicationState) => {
  return {
    ...selectAuth(state),
    company: selectCompany(state),
  };
})(AuthorizeRoute);
